//
// Copyright 2024 DXOS.org
//

export const ClientServicesProviderResource = Symbol.for('dxos.resource.ClientServices');
